import Button, { ButtonType } from 'legacy/common/components/button/Button';
import Modal, { ModalType } from 'legacy/common/components/modal/Modal';
import React from 'react';
import { useTranslation } from 'react-i18next';

interface PublishModalProps {
  isLoading: boolean;
  onClose: () => void;
  onPublish: () => void;
}

const PublishModal: React.FC<PublishModalProps> = ({
  isLoading,
  onClose,
  onPublish
}) => {
  const { t } = useTranslation(['events']);

  return (
    <Modal visible type={ModalType.ALERT}>
      <div className="px-4 text-center">
        <p className="text-6xl py-6">🚀</p>
        <p className="text-xl px-10 font-semibold">
          {t('events:createEvent.confirmation.title')}
        </p>

        <p className="mt-6 text-lg px-10 font-normal">
          {t('events:createEvent.confirmation.subtitle')}
        </p>

        <div className="mt-8">
          <Button
            type={ButtonType.Primary}
            onClick={onPublish}
            loading={isLoading}
          >
            {t('events:createEvent.confirmation.makeOfficial')}
          </Button>
        </div>

        <button
          type="button"
          className="text-base text-primary-500 mt-2 p-2 font-semibold"
          onClick={onClose}
        >
          {t('events:createEvent.confirmation.backToBuilder')}
        </button>
      </div>
    </Modal>
  );
};

export default PublishModal;
